<template>
  <div>
    <div class="form-group row">
      <div class="col-sm-1 col-form-label" v-if="showNoDateFilter != 1">Von</div>
      <div class="col-sm-2" v-if="showNoDateFilter != 1">
        <input
          type="date"
          name="start_date"
          class="form-control form-control-sm"
          :value="filterFromDate"
          @input="updateFilterFromDate"
        />
      </div>
      <div class="col-sm-1 col-form-label" v-if="showNoDateFilter != 1">Bis</div>
      <div class="col-sm-2" v-if="showNoDateFilter != 1">
        <input
          type="date"
          name="to_date"
          class="form-control form-control-sm"
          :value="filterToDate"
          @input="updateFilterToDate"
        />
      </div>

      <div class="col-sm-1 col-form-label" v-if="currentUser.master == 1">Shop</div>
      <div class="col-sm-2" v-if="currentUser.master == 1">
        <select
          class="form-control form-control-sm"
          :value="filterShopId"
          @input="updateFilterShop"
        >
          <option value="0"></option>
          <option v-for="shop in shopListing" :key="shop.id" :value="shop.id">{{shop.name}}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFilteringComponent",
  data() {
    return {};
  },
  props: {
    showNoDateFilter: Number
  },
  computed: {
    currentUser() {
      return this.$store.state.current_user;
    },
    shopListing() {
      return this.$store.state.shops;
    },
    filterShopId() {
      return this.$store.state.filter_shop_id;
    },
    filterFromDate() {
      return this.$store.state.filter_from_date;
    },
    filterToDate() {
      return this.$store.state.filter_to_date;
    }
  },
  methods: {
    updateFilterFromDate(e) {
      this.$store.commit("set_filter_from_date", e.target.value);
    },
    updateFilterToDate(e) {
      this.$store.commit("set_filter_to_date", e.target.value);
    },
    updateFilterShop(e) {
      this.$store.commit("set_filter_shop_id", e.target.value);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/BaseFilteringComponent.vue